// First-touch attribution. Captured once per browser on the first page load
// (never overwritten, expires after 90 days) and sent with the OAuth session
// exchange so the backend can store `signup_source` on NEW users.
const KEY = 'sdl_first_touch';
const TTL_MS = 90 * 24 * 60 * 60 * 1000;
const QUERY_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'];

const clip = (value, max) => (typeof value === 'string' ? value.trim().slice(0, max) : undefined);

/** The stored first touch, or null if absent / expired / unreadable. */
export function readFirstTouch() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    const capturedAt = Date.parse(data?.captured_at);
    if (!data || typeof data !== 'object' || !capturedAt || Date.now() - capturedAt > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

/** Record UTMs, ?ref, document.referrer and the landing path — first visit only. */
export function captureFirstTouch() {
  try {
    if (typeof window === 'undefined') return;
    // The OAuth callback (#session_id=…) is a hop through the auth provider, not an
    // acquisition touch — don't let it become a 90-day "first touch".
    if ((window.location.hash || '').includes('session_id=')) return;
    if (readFirstTouch()) return;

    const params = new URLSearchParams(window.location.search);
    const data = {
      captured_at: new Date().toISOString(),
      landing_path: clip(window.location.pathname, 200) || '/',
      referrer: clip(document.referrer || '', 500) || '',
    };
    QUERY_KEYS.forEach((k) => {
      const v = clip(params.get(k), 150);
      if (v) data[k] = v;
    });
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // storage blocked / private mode — attribution is best-effort
  }
}
